import { parsePhoneNumberFromString } from 'libphonenumber-js'

const DEFAULT_COUNTRY = 'NO'

export function parseOptionalPhoneNumber(value: string): { ok: true; normalized: string } | { ok: false } {
    const trimmed = value.trim()
    if (!trimmed) {
        return { ok: true, normalized: '' }
    }

    const parsed = parsePhoneNumberFromString(trimmed, DEFAULT_COUNTRY)
    if (!parsed?.isValid()) {
        return { ok: false }
    }

    return { ok: true, normalized: parsed.format('E.164') }
}
